import { useMemo } from 'react';

import qs from 'qs';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuides/landing/pageContext';
import { generateAiSapParam } from '#src/app/shared/utils/generateAiSapParam';

export const HEADING_DEFAULTS = {
	data: {
		title: 'title',
		description: '',
		image: { alt: '', url: '' },
		sapAiUrl: '//fake/url',
		sapUrl: '//fake/url',
	},
	actions: {
		trackSapClick: () => {},
		trackSapAiClick: () => {},
	},
};

type Result = ModelHookResult<
	{
		title: string;
		description: string;
		image: {
			alt: string;
			url: string;
		};
		sapAiUrl: string;
		sapUrl: string;
	},
	{
		trackSapClick: () => void;
		trackSapAiClick: () => void;
	}
>;

export function usePageHeading(): Result {
	const {
		data: {
			title,
			description,
			heroImage: { title: imageTitle, url: imageUrl },
			aiSapId,
		},
	} = usePetitionGuidesPageData();
	const track = useTracking();

	return {
		data: {
			title,
			description,
			image: {
				alt: imageTitle,
				url: imageUrl,
			},
			sapAiUrl: useMemo(
				() =>
					`/start-a-petition/intro?${qs.stringify({ state: generateAiSapParam(aiSapId), source_location: 'petition_guides_landing_page' })}`,
				[aiSapId],
			),
			sapUrl: '/start-a-petition/intro?source_location=petition_guides_landing_page',
		},
		actions: {
			trackSapClick: () => {
				void track('petition_guides_landing_page_sap_click_hero');
			},
			trackSapAiClick: () => {
				void track('petition_guides_landing_page_sap_ai_click_hero');
			},
		},
	};
}
